import type { Meeting } from '../../../services/meeting.service.ts';
import { isMeetingLiveActive } from './meetingLiveExpiry.ts';

/** Planlanan bitiş saati geçmiş ve şu an canlı olmayan toplantılar. */
export function isPastMeeting(meeting: Meeting, now = Date.now()): boolean {
  if (isMeetingLiveActive(meeting, now)) return false;
  if (meeting.status === 'ENDED' || meeting.status === 'CANCELLED') return true;
  if (!meeting.scheduledAt) return false;

  const endTime =
    new Date(meeting.scheduledAt).getTime() + (meeting.duration || 60) * 60_000;
  return endTime < now;
}

export function filterUpcomingMeetings(meetings: Meeting[], now = Date.now()): Meeting[] {
  return meetings
    .filter((m) => !m.isInstant && !isPastMeeting(m, now))
    .sort(
      (a, b) =>
        new Date(a.scheduledAt || 0).getTime() - new Date(b.scheduledAt || 0).getTime()
    );
}
